// biome-ignore lint/style/useNodejsImportProtocol: use 'events' module instead of node builtin
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ScriptManager", {
    enumerable: true,
    get: function() {
        return ScriptManager;
    }
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _interop_require_default = require("@swc/helpers/_/_interop_require_default");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var _events = /*#__PURE__*/ _interop_require_default._(require("events"));
var _tapable = require("tapable");
var _NativeScriptManager = /*#__PURE__*/ _interop_require_default._(require("./NativeScriptManager.js"));
var _Script = require("./Script.js");
var _getWebpackContext = require("./getWebpackContext.js");
var DEFAULT_RESOLVER_PRIORITY = 2;
var DEFAULT_RESOLVER_KEY = '__default__';
var CACHE_NAME = 'Repack.ScriptManager.Cache';
var CACHE_VERSION = 'v4';
var CACHE_ENV = __DEV__ ? 'debug' : 'release';
var CACHE_KEY = [
    CACHE_NAME,
    CACHE_VERSION,
    CACHE_ENV
].join('.');
var LOADING_ERROR_CODES = [
    // android
    'NetworkFailure',
    'RequestFailure',
    // ios
    'ScriptDownloadFailure'
];
function promisify(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _async_to_generator._(function*() {
            return fn.apply(void 0, _to_consumable_array._(args));
        })();
    };
}
var ScriptManager = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    _inherits._(ScriptManager, EventEmitter);
    function ScriptManager() {
        var nativeScriptManager = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _NativeScriptManager.default;
        _class_call_check._(this, ScriptManager);
        var _this;
        _this = _call_super._(this, ScriptManager), _this.cache = {}, _this.scriptsPromises = {}, _this.cacheInitialized = false, _this.resolvers = [], _this.hookMap = {
            beforeResolve: new _tapable.AsyncSeriesWaterfallHook([
                'args'
            ]),
            resolve: new _tapable.AsyncSeriesBailHook([
                'args'
            ]),
            afterResolve: new _tapable.AsyncSeriesWaterfallHook([
                'args'
            ]),
            errorResolve: new _tapable.AsyncSeriesBailHook([
                'args'
            ]),
            beforeLoad: new _tapable.AsyncSeriesWaterfallHook([
                'args'
            ]),
            load: new _tapable.AsyncSeriesBailHook([
                'args'
            ]),
            afterLoad: new _tapable.AsyncSeriesWaterfallHook([
                'args'
            ]),
            errorLoad: new _tapable.AsyncSeriesBailHook([
                'args'
            ])
        }, _this.hooks = {
            beforeResolve: (fn)=>_this.hookMap.beforeResolve.tapPromise('beforeResolve', promisify(fn)),
            resolve: (fn)=>_this.hookMap.resolve.tapPromise('resolve', promisify(fn)),
            afterResolve: (fn)=>_this.hookMap.afterResolve.tapPromise('afterResolve', promisify(fn)),
            errorResolve: (fn)=>_this.hookMap.errorResolve.tapPromise('errorResolve', promisify(fn)),
            beforeLoad: (fn)=>_this.hookMap.beforeLoad.tapPromise('beforeLoad', promisify(fn)),
            load: (fn)=>_this.hookMap.load.tapPromise('load', promisify(fn)),
            afterLoad: (fn)=>_this.hookMap.afterLoad.tapPromise('afterLoad', promisify(fn)),
            errorLoad: (fn)=>_this.hookMap.errorLoad.tapPromise('errorLoad', promisify(fn))
        };
        _this.nativeScriptManager = nativeScriptManager;
        if (!nativeScriptManager) {
            throw new Error('repack react-native module was not found.' + (__DEV__ ? ' Did you forget to update native dependencies?' : ''));
        }
        if (__webpack_require__.repack.shared.scriptManager) {
            throw new Error('ScriptManager was already instantiated. Use ScriptManager.shared instead.');
        }
        __webpack_require__.repack.shared.scriptManager = _this;
        var enqueuedResolvers = __webpack_require__.repack.shared.enqueuedResolvers;
        while(enqueuedResolvers.length){
            // process deferred resolvers in First-In-First-Out (FIFO) order to maintain
            // the sequence in which they were registered before ScriptManager initialization
            var _enqueuedResolvers_shift = _sliced_to_array._(enqueuedResolvers.shift(), 2), resolver = _enqueuedResolvers_shift[0], options = _enqueuedResolvers_shift[1];
            _this.addResolver(resolver, options);
        }
        return _this;
    }
    _create_class._(ScriptManager, [
        {
            /**
   * Sets a storage backend to cache resolved scripts locator data.
   *
   * The stored data is used to detect if scripts locator data of previously downloaded
   * script hasn't changed to avoid over-fetching the script.
   *
   * @param storage Implementation of storage functions.
   */ key: "setStorage",
            value: function setStorage(storage) {
                this.storage = storage;
            }
        },
        {
            /**
   * Adds new script locator resolver.
   *
   * Resolver is an async function to resolve script locator data - in other words, it's a function to
   * tell the {@link ScriptManager} how to fetch the script.
   *
   * There's no limitation on what logic you can run inside this function - it can include:
   * - fetching/loading remote config
   * - fetching/loading feature flags
   * - fetching/loading A/B testing data
   * - calling native modules
   * - running arbitrary logic
   *
   * @param resolver Resolver function to add.
   * @param options Resolver options.
   */ key: "addResolver",
            value: function addResolver(resolver) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var priority = options.priority ?? DEFAULT_RESOLVER_PRIORITY;
                var uniqueKey = options.key;
                this.resolvers = this.resolvers.filter((param)=>{
                    var _param = _sliced_to_array._(param, 1), key = _param[0];
                    return key !== uniqueKey;
                }).concat([
                    [
                        uniqueKey ?? DEFAULT_RESOLVER_KEY,
                        priority,
                        resolver
                    ]
                ]).sort((param, param1)=>{
                    var _param = _sliced_to_array._(param, 2), a = _param[1], _param1 = _sliced_to_array._(param1, 2), b = _param1[1];
                    return Number(b) - Number(a);
                });
            }
        },
        {
            /**
   * Removes previously added resolver.
   *
   * @param resolver Resolver function or resolver's `uniqueKey` to remove.
   * @returns `true` if resolver was found and removed, `false` otherwise.
   */ key: "removeResolver",
            value: function removeResolver(resolver) {
                var index;
                if (typeof resolver === 'string') {
                    index = this.resolvers.findIndex((param)=>{
                        var _param = _sliced_to_array._(param, 1), key = _param[0];
                        return key === resolver;
                    });
                } else {
                    index = this.resolvers.findIndex((param)=>{
                        var _param = _sliced_to_array._(param, 3), item = _param[2];
                        return item === resolver;
                    });
                }
                if (index > -1) {
                    this.resolvers.splice(index, 1);
                    return true;
                }
                return false;
            }
        },
        {
            /**
   * Removes all previously added resolvers.
   */ key: "removeAllResolvers",
            value: function removeAllResolvers() {
                this.resolvers = [];
            }
        },
        {
            key: "initCache",
            value: function initCache() {
                return _async_to_generator._(function*() {
                    if (!this.cacheInitialized) {
                        var _this_storage;
                        var cacheEntry = yield (_this_storage = this.storage) === null || _this_storage === void 0 ? void 0 : _this_storage.getItem(CACHE_KEY);
                        this.cache = cacheEntry ? JSON.parse(cacheEntry) : {};
                        this.cacheInitialized = true;
                    }
                }).call(this);
            }
        },
        {
            key: "saveCache",
            value: function saveCache() {
                return _async_to_generator._(function*() {
                    var _this_storage;
                    yield (_this_storage = this.storage) === null || _this_storage === void 0 ? void 0 : _this_storage.setItem(CACHE_KEY, JSON.stringify(this.cache));
                }).call(this);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var _console;
                (_console = console).error.apply(_console, [
                    message
                ].concat(_to_consumable_array._(args), [
                    {
                        originalError: error
                    }
                ]));
                this.emit('error', {
                    message,
                    args,
                    originalError: error
                });
                throw error;
            }
        },
        {
            key: "resolveScript",
            value: /**
   * Resolves a {@link Script} instance with normalized locator data.
   *
   * Resolution will use previously added (via `ScriptManager.shared.addResolver(...)`) resolvers
   * in series, util one returns a locator data or will throw if no resolver handled the request.
   *
   * Use `ScriptManager.shared.on('resolving', ({ scriptId, caller }) => { })` to listen for when
   * the script resolution begins.
   *
   * Use `ScriptManager.shared.on('resolved', (script) => { })` to listen for when
   * the script's locator data is resolved.
   *
   * @param scriptId Id of the script to resolve.
   * @param caller Name of the calling script - it can be for example: name of the bundle, chunk or container.
   */ // NOTE: Keep declaration and implementation separate
            // to allow for better naming in JSDocs while preventing
            // using the arguments directly in the implementation
            function resolveScript(_0, _1, _2) {
                return _async_to_generator._(function*(__scriptId, __caller) {
                    var __webpackContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _getWebpackContext.getWebpackContext)(), __referenceUrl = arguments.length > 3 ? arguments[3] : void 0;
                    var options = {
                        scriptId: __scriptId,
                        caller: __caller,
                        referenceUrl: __referenceUrl,
                        webpackContext: __webpackContext
                    };
                    var locator;
                    try {
                        yield this.initCache();
                        if (!this.resolvers.length) {
                            throw new Error('No script resolvers were added. Did you forget to call `ScriptManager.shared.addResolver(...)`?');
                        }
                        if (this.hookMap.beforeResolve.isUsed()) {
                            options = (yield this.hookMap.beforeResolve.promise({
                                options
                            })).options;
                        }
                        this.emit('resolving', {
                            scriptId: options.scriptId,
                            caller: options.caller
                        });
                        if (this.hookMap.resolve.isUsed()) {
                            // obtain the result from custom implementation through the resolve hook
                            locator = yield this.hookMap.resolve.promise({
                                options,
                                resolvers: this.resolvers
                            });
                        } else {
                            // obtain the result from default implementation
                            for (var ref of this.resolvers){
                                var _ref = _sliced_to_array._(ref, 3), resolve = _ref[2];
                                var resolvedLocator = yield resolve(options.scriptId, options.caller, options.referenceUrl);
                                if (resolvedLocator) {
                                    locator = resolvedLocator;
                                    break;
                                }
                            }
                        }
                        if (!locator) {
                            throw new Error(`No resolver was able to resolve script ${options.scriptId}`);
                        }
                        if (this.hookMap.afterResolve.isUsed()) {
                            var ref1;
                            ref1 = yield this.hookMap.afterResolve.promise({
                                options,
                                locator
                            }), options = ref1.options, locator = ref1.locator, ref1;
                        }
                        if (typeof locator.url === 'function') {
                            locator.url = locator.url(options.webpackContext);
                        }
                    } catch (error) {
                        locator = yield this.hookMap.errorResolve.promise({
                            options,
                            error: error
                        });
                        if (!locator) {
                            this.handleError(error, '[ScriptManager] Failed while resolving script locator:', {
                                scriptId: options.scriptId,
                                caller: options.caller
                            });
                        }
                    }
                    try {
                        var script = yield this.createScript(options.scriptId, options.caller, locator);
                        this.emit('resolved', script.toObject());
                        return script;
                    } catch (error) {
                        this.handleError(error, '[ScriptManager] Failed while creating script:', {
                            scriptId: options.scriptId,
                            caller: options.caller
                        });
                    }
                }).apply(this, arguments);
            }
        },
        {
            key: "createScript",
            value: function createScript(scriptId, caller, locator) {
                return _async_to_generator._(function*() {
                    var script = _Script.Script.from({
                        scriptId,
                        caller
                    }, locator, false);
                    var cacheKey = script.locator.uniqueId;
                    // Check if user provided a custom shouldUpdateScript function
                    if (locator.shouldUpdateScript) {
                        // If so, we need to wait for it to resolve
                        var fetch = yield locator.shouldUpdateScript(scriptId, caller, script.shouldUpdateCache(this.cache[cacheKey]));
                        // If it returns true, we need to fetch the script
                        if (fetch) {
                            script.locator.fetch = true;
                        }
                    } else {
                        // If no custom shouldUpdateScript function was provided, we use the default behaviour
                        if (!this.cache[cacheKey]) {
                            script.locator.fetch = true;
                        } else if (script.shouldRefetch(this.cache[cacheKey])) {
                            script.locator.fetch = true;
                        }
                    }
                    return script;
                }).call(this);
            }
        },
        {
            key: "updateCache",
            value: function updateCache(script) {
                return _async_to_generator._(function*() {
                    if (script.locator.fetch) {
                        var cacheKey = script.locator.uniqueId;
                        this.cache[cacheKey] = script.getCacheData();
                        yield this.saveCache();
                    }
                }).call(this);
            }
        },
        {
            key: "loadScript",
            value: /**
   * Resolves given script's location, downloads and executes it.
   * The execution of the code is handled internally by threading in React Native.
   *
   * Use `ScriptManager.shared.on('loading', (script) => { })` to listen for when
   * the script is about to be loaded.
   *
   * Use `ScriptManager.shared.on('loaded', (script) => { })` to listen for when
   * the script is loaded.
   *
   * @param scriptId Id of the script to load.
   * @param caller Name of the calling script - it can be for example: name of the bundle, chunk or container.
   */ // NOTE: Keep declaration and implementation separate
            // to allow for better naming in JSDocs while preventing
            // using the arguments directly in the implementation
            function loadScript(_0, _1, _2) {
                return _async_to_generator._(function*(__scriptId, __caller) {
                    var __webpackContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _getWebpackContext.getWebpackContext)(), __referenceUrl = arguments.length > 3 ? arguments[3] : void 0;
                    var options = {
                        scriptId: __scriptId,
                        caller: __caller,
                        referenceUrl: __referenceUrl,
                        webpackContext: __webpackContext
                    };
                    var loaded = false;
                    var uniqueId = _Script.Script.getScriptUniqueId(options.scriptId, options.caller);
                    if (this.scriptsPromises[uniqueId]) {
                        var isPrefetch = this.scriptsPromises[uniqueId].isPrefetch;
                        // prefetch is not execute the script so we need to run loadScript if promise is for prefetch
                        if (isPrefetch) {
                            yield this.scriptsPromises[uniqueId];
                        } else {
                            return this.scriptsPromises[uniqueId];
                        }
                    }
                    var loadProcess = ()=>_async_to_generator._(function*() {
                            var script = yield this.resolveScript(options.scriptId, options.caller, options.webpackContext, options.referenceUrl);
                            try {
                                if (this.hookMap.beforeLoad.isUsed()) {
                                    var ref;
                                    ref = yield this.hookMap.beforeLoad.promise({
                                        options,
                                        script
                                    }), options = ref.options, script = ref.script, ref;
                                }
                                this.emit('loading', script.toObject());
                                if (this.hookMap.load.isUsed()) {
                                    var _this = this;
                                    loaded = yield this.hookMap.load.promise({
                                        options,
                                        script,
                                        loadScript: function loadScript() {
                                            var scriptId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : options.scriptId, locator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : script.locator;
                                            return _async_to_generator._(function*() {
                                                yield this.loadScriptWithRetry(scriptId, locator);
                                            }).call(_this);
                                        }
                                    });
                                } else {
                                    yield this.loadScriptWithRetry(options.scriptId, script.locator);
                                    loaded = true;
                                }
                                if (this.hookMap.afterLoad.isUsed()) {
                                    var ref1;
                                    ref1 = yield this.hookMap.afterLoad.promise({
                                        options,
                                        script
                                    }), options = ref1.options, script = ref1.script, ref1;
                                }
                                this.emit('loaded', script.toObject());
                                yield this.updateCache(script);
                            } catch (error) {
                                var code = error.code;
                                loaded = yield this.hookMap.errorLoad.promise({
                                    options,
                                    error: error
                                });
                                if (!loaded) {
                                    this.handleError(error, '[ScriptManager] Failed to load script:', code ? `[${code}]` : '', script.toObject());
                                }
                            } finally{
                                // should delete script promise even script failed
                                delete this.scriptsPromises[uniqueId];
                            }
                        }).call(this);
                    this.scriptsPromises[uniqueId] = loadProcess();
                    return this.scriptsPromises[uniqueId];
                }).apply(this, arguments);
            }
        },
        {
            key: "loadScriptWithRetry",
            value: /**
   * Loads a script with retry logic.
   *
   * This function attempts to load a script using the nativeScriptManager.
   * If the initial attempt fails, it retries the specified number of times
   * with an optional delay between retries.
   *
   * @param {string} scriptId - The ID of the script to load.
   * @param {NormalizedScriptLocator} locator - An NormalizedScriptLocator containing retry configuration.
   * @param {number} [locator.retry=0] - The number of retry attempts.
   * @param {number} [locator.retryDelay=0] - The delay in milliseconds between retries.
   * @throws {Error} Throws an error if all retry attempts fail.
   */ function loadScriptWithRetry(scriptId, locator) {
                return _async_to_generator._(function*() {
                    var _locator_retry = locator.retry, retry = _locator_retry === void 0 ? 0 : _locator_retry, _locator_retryDelay = locator.retryDelay, retryDelay = _locator_retryDelay === void 0 ? 0 : _locator_retryDelay;
                    var attempts = retry + 1; // Include the initial attempt
                    while(attempts > 0){
                        try {
                            yield this.nativeScriptManager.loadScript(scriptId, locator);
                            return; // Successfully loaded the script, exit the loop
                        } catch (error) {
                            attempts--;
                            var code = error.code;
                            if (attempts > 0 && LOADING_ERROR_CODES.includes(code)) {
                                if (retryDelay > 0) {
                                    yield new Promise((resolve)=>setTimeout(resolve, retryDelay));
                                }
                            } else {
                                throw error; // No more retries, throw the error
                            }
                        }
                    }
                }).call(this);
            }
        },
        {
            key: "prefetchScript",
            value: /**
   * Resolves given script's location and downloads it without executing.
   * This function can be awaited to detect if the script was downloaded and for error handling.
   *
   * Use `ScriptManager.shared.on('prefetching', (script) => { })` to listen for when
   * the script's prefetch beings.
   *
   * @param scriptId Id of the script to prefetch.
   * @param caller Name of the calling script - it can be for example: name of the bundle, chunk or container.
   */ function prefetchScript(_0, _1, _2) {
                return _async_to_generator._(function*(scriptId, caller) {
                    var webpackContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _getWebpackContext.getWebpackContext)(), referenceUrl = arguments.length > 3 ? arguments[3] : void 0;
                    var uniqueId = _Script.Script.getScriptUniqueId(scriptId, caller);
                    if (this.scriptsPromises[uniqueId]) {
                        return this.scriptsPromises[uniqueId];
                    }
                    var loadProcess = ()=>_async_to_generator._(function*() {
                            var script = yield this.resolveScript(scriptId, caller, webpackContext, referenceUrl);
                            try {
                                this.emit('prefetching', script.toObject());
                                yield this.nativeScriptManager.prefetchScript(scriptId, script.locator);
                                yield this.updateCache(script);
                            } catch (error) {
                                var code = error.code;
                                this.handleError(error, '[ScriptManager] Failed to prefetch script:', code ? `[${code}]` : '', script.toObject());
                            } finally{
                                // should delete script promise even script failed
                                delete this.scriptsPromises[uniqueId];
                            }
                        }).call(this);
                    this.scriptsPromises[uniqueId] = loadProcess();
                    this.scriptsPromises[uniqueId].isPrefetch = true;
                    return this.scriptsPromises[uniqueId];
                }).apply(this, arguments);
            }
        },
        {
            key: "invalidateScripts",
            value: /**
   * Clears the cache (if configured in {@link ScriptManager.setStorage}) and removes downloaded
   * files for given scripts from the filesystem. This function can be awaited to detect if the
   * scripts were invalidated and for error handling.
   *
   * Use `ScriptManager.shared.on('invalidated', (scriptIds) => { })` to listen for when
   * the invalidation completes.
   *
   * @param scriptIds Array of script ids to clear from cache and remove from filesystem.
   * @returns Array of script ids that were invalidated.
   */ function invalidateScripts() {
                return _async_to_generator._(function*() {
                    var scriptIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                    try {
                        yield this.initCache();
                        var ids = scriptIds.length ? scriptIds : Object.keys(this.cache);
                        ids.forEach((scriptId)=>{
                            delete this.cache[scriptId];
                            delete this.scriptsPromises[scriptId];
                        });
                        yield this.saveCache();
                        yield this.nativeScriptManager.invalidateScripts(scriptIds);
                        this.emit('invalidated', ids);
                        return ids;
                    } catch (error) {
                        var code = error.code;
                        this.handleError(error, '[ScriptManager] Failed to invalidate scripts:', code ? `[${code}]` : '');
                    }
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Evaluates a script synchronously.
   *
   * This function sends the script source and its URL to the native script manager for evaluation.
   * It is functionally identical to `globalEvalWithSourceUrl`.
   *
   * @param scriptSource The source code of the script to evaluate.
   * @param scriptSourceUrl The URL of the script source, used for debugging purposes.
   */ key: "unstable_evaluateScript",
            value: function unstable_evaluateScript(scriptSource, scriptSourceUrl) {
                this.nativeScriptManager.unstable_evaluateScript(scriptSource, scriptSourceUrl);
            }
        }
    ], [
        {
            key: "init",
            value: function init() {
                if (!__webpack_require__.repack.shared.scriptManager) {
                    __webpack_require__.repack.shared.scriptManager = new ScriptManager();
                }
            }
        },
        {
            key: "shared",
            get: function get() {
                return __webpack_require__.repack.shared.scriptManager;
            }
        }
    ]);
    return ScriptManager;
}(_events.default);
